"use client";

import { MapPin, Phone, Mail, Linkedin, Twitter, Facebook } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-2">
        {[...Array(3)].map((_, i) => <div key={i} className="h-5 w-24 bg-muted/20 rounded-md animate-pulse" />)}
      </div>;
  }
  return <nav className="space-y-2">
      {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-seafoam-white/80 hover:text-primary transition-colors text-sm font-default">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const services = ["All Collars", "New Arrivals", "Best Sellers", "Custom Orders"];
  const socialLinks = [{
    icon: Linkedin,
    href: "#",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }];
  return <footer data-section-id="264733" id="footer" className="dark bg-[#111111] text-white relative overflow-hidden">
      {}
      <div className="max-w-7xl mx-auto px-6 py-12 lg:py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          
          {}
          <div className="space-y-4">
            <Link to="/">
              <WvcLogo className="h-8 w-auto brightness-0 invert" />
            </Link>
            <p className="text-seafoam-white/70 text-sm leading-relaxed font-default">
              Handcrafted beach-inspired dog collars for the surf loving pup. Designed for comfort, style, and the spirit of coastal living.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-white mb-4 text-lg tracking-wide">Learn</h3>
            <MenuProvider menu_id="78" className="space-y-0">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-white mb-4 text-lg tracking-wide">Shop</h3>
            <nav className="space-y-2">
              {services.map((service, index) => <Link key={index} to="/ShopPage" className="text-seafoam-white/80 hover:text-primary transition-colors text-sm font-default">
                  {service}
                </Link>)}
            </nav>
          </div>

          {}
          <div className="space-y-4">
            <h3 className="font-default font-semibold text-white text-lg tracking-wide">Support</h3>
            <div className="space-y-3 text-sm text-seafoam-white/70 font-default">
              <div className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary" />
                <Link to="#" className="hover:text-primary transition-colors">
                  Contact Us
                </Link>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary" />
                <Link to="#" className="hover:text-primary transition-colors">
                  Shipping & Returns
                </Link>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary" />
                <span>Designed in Southern California</span>
              </div>
            </div>

            {}
            <div className="flex gap-3 pt-4">
              {socialLinks.map((social, index) => <Link key={index} to={social.href} className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-zinc-900 text-seafoam-white/80 hover:bg-primary hover:text-primary-foreground transition-all shadow-md" aria-label={social.label}>
                  <social.icon className="w-5 h-5" />
                </Link>)}
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute right-0 bottom-0 opacity-10 pointer-events-none hidden lg:block">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612773/img/vintage_surfboard_decorative.png" alt="Decorative Surfboard" className="h-96 w-auto object-contain" />
      </div>

      {}
      <div className="border-t border-zinc-800/50">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-seafoam-white/50 text-[12px] text-center md:text-left font-default">
            © {new Date().getFullYear()} SurfPup.store. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-seafoam-white/50 text-[12px] font-default">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Sitemap
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}